import React from 'react';

const ConfidenceBar = ({ 
  currentValue, 
  coreValue 
}) => {
  // Calculate confidence
  const isPerfectMatch = currentValue?.toLowerCase().trim() === coreValue?.toLowerCase().trim();
  
  // Check for "No Data" scenario: both values are "Not Found"
  const isNoData = currentValue?.toLowerCase().trim() === 'not found' && coreValue?.toLowerCase().trim() === 'not found';
  
  const confidence = isNoData ? 0.0 : (isPerfectMatch ? 1.0 : 0.2);
  
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <span style={{ fontSize: '0.875rem', fontWeight: '500', color: '#374151' }}>Match:</span>
      <div style={{ 
        width: '200px', 
        height: '12px', 
        background: '#e5e7eb', 
        borderRadius: '6px', 
        overflow: 'hidden',
        marginTop: '2px'
      }}>
        <div style={{ 
          height: '100%', 
          width: `${confidence * 100}%`,
          background: isNoData ? '#6b7280' : (confidence >= 0.95 ? '#10b981' : confidence >= 0.8 ? '#f59e0b' : '#ef4444'),
          transition: 'width 0.3s ease'
        }} />
      </div>
      <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>
        {isNoData ? 'No Data' : (confidence >= 1.0 ? 'Perfect Match' : `${Math.round(confidence * 100)}%`)}
      </span>
    </div>
  );
};

export default ConfidenceBar;
